const state = {
  show: true
};

const getters = {
  getShow: state => state.show
};

const mutations = {
  SET_SHOW: (state, show) => {
    state.show = show
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/echarts.js